<script setup>
import { watch } from 'vue';

import { addIcon, deleteIcon, draggableIcon, commentIcon } from '../../utils/icons'
import { useTestStore } from '../../stores/TestStore'
import { useDraggable } from '../../composables/draggable.js'

const testStore = useTestStore()

const { draggedItem, dragOverItem, handleDragStart, handleDragOver, handleDragReset, handleDragEnd } = useDraggable()

function handleDrop(index) {
  testStore.aux_cambia_posicion(testStore.dimensiones, draggedItem.value, index)
  handleDragReset()
}

function addDiagnostico(dimension){
  dimension.diagnosticos.push({
    "from": 0,
    "to": 1,
    "descripcion": ""
  })
}

</script>

<template>

  <div class="dimensiones-test my-5">

    <div class="flex justify-between border-b-2 mb-5 pb-2">
      <h5 class="font-bold text-blue-700">Dimensiones</h5>
      <span class="button-text-icon-sm" type="button" @click="testStore.add_dimension">
        <i v-html='addIcon'></i><span class="mx-2">Añadir</span>
      </span>
    </div>

    <div class="mb-1" >
      <div class="flex flex-row space-x-4 font-bold mb-2">
        <div class="w-3/12">Nombre</div> 
        <div class="w-5/12">Descripción</div>
        <div class="w-1/12">Min</div>
        <div class="w-1/12">Max</div>
        <div class="w-12"></div>
        <div class="w-12"></div>
        <div class="w-12"></div>
      </div>
    </div>

    
    <div class="sortable-list">
      
      
      <div 
        v-for="(dimension, index) in testStore.dimensiones" :key="dimension.id" 
        class="dimension-test mb-1 "
        :draggable="true"
        @dragstart="handleDragStart(index)"
        @dragover="handleDragOver($event, index)"
        @drop="handleDrop(index)"
        @dragend="handleDragEnd"
        :class="{ 'bg-blue-200': index === draggedItem, 'border-2 border-dashed border-blue-200': index == dragOverItem && index != draggedItem }"
        >

        <div class="flex flex-row space-x-4">
          <div class="w-3/12"><input class="input-f" v-model="dimension.nombre" type="text" placeholder="Nombre"></div> 
          <div class="w-5/12"><textarea  class="textarea-f h-10" v-model="dimension.descripcion" placeholder="Descripción ..."></textarea></div>
          <div class="w-1/12"><span class="input-f text-center pt-2 bg-gray-100">{{ dimension.puntos_min }}</span></div>
          <div class="w-1/12"><span class="input-f text-center pt-2 bg-gray-100">{{ dimension.puntos_max }}</span></div>
          <div class="w-12">
            <span class="button-icon-out-gray-red" type="button" @click="testStore.delete_dimension(dimension.id)">
              <i v-html='deleteIcon'></i>
            </span>    
          </div>
          <div class="w-12">
            <span class="button-icon-out-gray-blue" type="button"><i v-html='draggableIcon'></i></span>    
          </div>
          <div class="w-12">
            <span class="button" type="button" @click="addDiagnostico(dimension)"><i v-html='commentIcon'></i></span>    
          </div>
        </div>

        <div class="ml-10 border-l-4 pl-5">
          <div v-for="(diagnostico, index) in dimension.diagnosticos" :key="index.id" class="flex items-center my-3">
            <div class="font-bold mx-3">Desde:</div>
            <div class="w-1/12"><input class="input-f" v-model="diagnostico.from" type="number" placeholder="Desde"></div>
            <div class="font-bold mx-3">Hasta:</div>
            <div class="w-1/12"><input class="input-f" v-model="diagnostico.to" type="number" placeholder="Hasta"></div>
            <div class="font-bold mx-3">Diagnóstico:</div>
            <div class="w-6/12"><textarea  class="textarea-f h-10" v-model="diagnostico.descripcion" placeholder="Descripción del diagnóstico ..."></textarea></div>
          </div>
        </div>

      </div>


    </div>

  </div>

</template>


<style lang="scss">


</style>